const envJson = require('../../.env.json');

const logger = namespace => {
  const namespacePrefix = namespace ? `[${namespace}] ` : '';
  let colorMap = {};
  //Set a random color for the namespace
  const getColorForNamespace = namespace => {
    if (!colorMap[namespace]) {
      colorMap[namespace] = getRandomColor();
    }
    return colorMap[namespace];
  };

  // Obtener el color para el namespace actual
  const color = namespace ? getColorForNamespace(namespace) : getRandomColor();

  const isDebug = envJson.DEBUG_LEVEL;

  let previousTimestamp = Date.now();

  const debug = (...args) => {
    if (!isDebug) return;
    const elapsed = measureTime();
    console.debug(`%c${namespacePrefix}`, `color:${color}`, ...args, elapsed);
  };

  const info = (...args) => {
    const elapsed = measureTime();
    console.log(`%c${namespacePrefix}`, `color:${color}`, ...args, elapsed);
  };

  const warn = (...args) => {
    const elapsed = measureTime();
    console.warn(`[${namespacePrefix}]`, ...args, elapsed);
  };

  const error = (...args) => {
    const elapsed = measureTime();
    console.error(`[${namespacePrefix}]`, ...args, elapsed);
    console.trace();
  };

  const measureTime = () => {
    const currentTimestamp = Date.now();
    const diff = currentTimestamp - previousTimestamp;
    previousTimestamp = currentTimestamp;
    return diff < 1000 ? `+${diff}ms` : `+${diff / 1000}s`;
  };

  return { debug, info, warn, error };
};

const dumbLogger = () => {
  const debug = (...args) => {};
  const info = (...args) => {};
  const warn = (...args) => {};
  const error = (...args) => {};
  return { debug, info, warn, error };
};

const getRandomColor = () => {
  const letters = '0123456789ABCDEF';
  let color = '#';
  for (let i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
};

module.exports = envJson.LOGGER ? logger : dumbLogger;
